export const getDomainName = (): string => {
  let hostname = window.location.hostname.split('.').at(-1);
  if (hostname.length > 3) {
    hostname = 'com';
  }
  return hostname;
};
